import { gettext } from '@eventbrite/i18n';
import { EventDescriptionProps } from '../EventDetails/EventDescription/EventDescription';

export enum TAB_NAVIGATION_IDS {
    INFO = 'when-and-where',
    DETAILS = 'about-this-event',
    FAQ = 'faq',
    ORGANIZER = 'organizer-panel',
    RELATED = 'related-events',
}

export interface TabNavigationItem {
    label: string;
    id: TAB_NAVIGATION_IDS;
}

export const TAB_NAVIGATION_ITEMS_SORTED = [
    TAB_NAVIGATION_IDS.INFO,
    TAB_NAVIGATION_IDS.DETAILS,
    TAB_NAVIGATION_IDS.FAQ,
    TAB_NAVIGATION_IDS.ORGANIZER,
    TAB_NAVIGATION_IDS.RELATED,
];

export const TAB_NAVIGATION_ITEMS = {
    [TAB_NAVIGATION_IDS.INFO]: {
        label: gettext('Info').toString(),
        id: TAB_NAVIGATION_IDS.INFO,
    },
    [TAB_NAVIGATION_IDS.DETAILS]: {
        label: gettext('Details').toString(),
        id: TAB_NAVIGATION_IDS.DETAILS,
    },
    [TAB_NAVIGATION_IDS.ORGANIZER]: {
        label: gettext('Organizer').toString(),
        id: TAB_NAVIGATION_IDS.ORGANIZER,
    },
    [TAB_NAVIGATION_IDS.RELATED]: {
        label: gettext('Related').toString(),
        id: TAB_NAVIGATION_IDS.RELATED,
    },
    [TAB_NAVIGATION_IDS.FAQ]: {
        label: gettext('FAQ').toString(),
        id: TAB_NAVIGATION_IDS.FAQ,
    },
};

export const getTabNavigationItems = (
    eventDescription?: EventDescriptionProps,
): TabNavigationItem[] => {
    const hasFaqs = eventDescription?.structuredContent?.widgets.some(
        (widget) => widget.type === 'faqs',
    );
    const tabNavigationItemsIds = [
        TAB_NAVIGATION_IDS.INFO,
        TAB_NAVIGATION_IDS.DETAILS,
        ...(hasFaqs ? [TAB_NAVIGATION_IDS.FAQ] : []),
        TAB_NAVIGATION_IDS.ORGANIZER,
        TAB_NAVIGATION_IDS.RELATED,
    ];

    return tabNavigationItemsIds.map((id) => TAB_NAVIGATION_ITEMS[id]);
};
